import { DisplayPosition } from '@/common/manager/position/display-position';
import React from 'react';
import { makeFilterItem, makeFormItemSchema } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
import { CnFilterItem as UICnFilterItem, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import './compose.scss';
export const config = {
    position: [
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.form,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Compose',
    component: 'div',
    formComponent: formComponentMap.CnFormGrid,
    filterItemBeforeHandler: (filterItemProps) => {
        if (filterItemProps) {
            filterItemProps.name = undefined;
            filterItemProps.className = 'cn-filter-item-compose';
        }
    },
    formItemBeforeHandler: (formItem, _config) => {
        const { formItemConfig = {}, formProps = {}, state, _context, urlParams, formValue, formInstance, isDesign, usedComponentList, } = _config || {};
        if (formItem) {
            const { options = {} } = formItemConfig;
            const { config = [] } = options;
            const componentProps = formItem['x-component-props'];
            const configLength = Array.isArray(config) ? config.length : 0;
            if (isPlainObject(componentProps)) {
                componentProps.config = undefined;
                componentProps.hasClear = undefined;
                if (configLength) {
                    componentProps.cols = config.length;
                }
            }
            formItem.properties = {};
            if (configLength) {
                config.forEach((item) => {
                    const { name } = item || {};
                    const gridFormItem = makeFormItemSchema({
                        formItemConfig: item,
                        isDesign,
                        urlParams,
                        formValue,
                        state,
                        usedComponentList,
                        formProps,
                        _context,
                        formInstance,
                    });
                    if (gridFormItem?.['x-decorator-props']) {
                        gridFormItem['x-decorator-props'].labelCol = {
                            hidden: true,
                        };
                    }
                    formItem.properties[name] = gridFormItem;
                });
            }
        }
    },
    getRenderDom: (iconfig) => {
        const { filterItemConfig, _context } = iconfig || {};
        const { options } = filterItemConfig || {};
        const { config } = options || {};
        if (Array.isArray(config) && config.length > 0) {
            const result = [];
            config.forEach((item, index) => {
                const { name } = item || {};
                if (name) {
                    const filterItemResult = makeFilterItem({
                        ...iconfig,
                        filterItemConfig: item,
                    });
                    if (isPlainObject(filterItemResult)) {
                        const { filterItemProps, component, componentProps } = filterItemResult;
                        let realDom;
                        if (component) {
                            realDom = (<UICnFilterItem key={index} {...filterItemProps} label={undefined} style={{ width: '100%' }}>
                  {React.createElement(component, {
                                    ...componentProps,
                                    name,
                                    _context,
                                })}
                </UICnFilterItem>);
                        }
                        if (realDom) {
                            result.push(realDom);
                        }
                    }
                }
            });
            if (result.length > 0) {
                return (<div className="cn-filter-item-compose-form-item-control">
            {result}
          </div>);
            }
        }
    },
};
